import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useLanguage } from "@/i18n";
import { api } from "@/api";

const PaymentSuccess = () => {
  const { t } = useLanguage();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    if (!sessionId) {
      setStatus("failed");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
      } catch (e) {}
      attempts += 1;
      if (attempts < 15) setTimeout(poll, 2000);
      else setStatus("failed");
    };
    poll();
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page" className="pt-24 min-h-[80vh] flex items-center">
      <div className="max-w-2xl mx-auto px-6 text-center py-32">
        {status === "pending" && (
          <>
            <Loader2 size={56} className="mx-auto text-clay animate-spin" />
            <h1 className="mt-8 font-serif text-4xl md:text-5xl text-forest" data-testid="payment-pending-title">{t("payment.pendingTitle")}</h1>
            <p className="mt-4 text-sage">{t("payment.pendingText")}</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={56} className="mx-auto text-moss" />
            <h1 className="mt-8 font-serif text-4xl md:text-6xl text-forest" data-testid="payment-success-title">{t("payment.successTitle")}</h1>
            <p className="mt-4 text-sage text-lg">{t("payment.successText")}</p>
            <Link to="/" data-testid="payment-back-home" className="mt-10 inline-flex bg-forest text-cream px-8 py-4 rounded-full font-medium hover:bg-clay hover:-translate-y-0.5 transition-transform duration-300">
              {t("payment.backHome")}
            </Link>
          </>
        )}
        {status === "failed" && (
          <>
            <XCircle size={56} className="mx-auto text-clay" />
            <h1 className="mt-8 font-serif text-4xl md:text-5xl text-forest" data-testid="payment-fail-title">{t("payment.failTitle")}</h1>
            <p className="mt-4 text-sage">{t("payment.failText")}</p>
            <Link to="/" data-testid="payment-back-home-fail" className="mt-10 inline-flex bg-forest text-cream px-8 py-4 rounded-full font-medium hover:bg-clay hover:-translate-y-0.5 transition-transform duration-300">
              {t("payment.backHome")}
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
